import { gql } from '@apollo/client';

export const TERMS_OF_SERVICE_SAVE_MUTATION = gql`
  mutation ($termsOfServiceCreateDto: TermsOfServiceCreateDto!) {
    saveTermsOfService(termsOfServiceCreateDto: $termsOfServiceCreateDto) {
      email
      version
    }
  }
`;
